import React from 'react';

import '../../utils/styles/Emergency.css';

function Emergency() {
    return (
        <div className="container">
            <p className="title-3">Numéros d'urgence</p>
            <p id="emergency-text">
                Lorsque vous appelez le <strong>100</strong>,{' '}
                <strong>101</strong> ou <strong>112</strong>, assurez-vous de
                fournir des informations précises sur la nature des faits ainsi
                que sur l'adresse ou le lieu de l'incident, en donnant le plus
                de détails possible.
            </p>
            <div id="emergency-num">
                <p className="num">
                    Numéro d'urgence européen (ambulances, pompiers et police) :{' '}
                    <a href="tel:112">112</a>
                </p>
                <p className="num">
                    Numéro d'urgence UNamur (24h/24, 7j/7) :{' '}
                    <a href="tel:081725000">081 72 50 00</a>
                </p>
                <p className="num">
                    Aide médicale et pompiers : <a href="tel:100">100</a>
                </p>
                <p className="num">
                    Service de police : <a href="tel:101">101</a>
                </p>
                <p className="num">
                    Secrétariat VéCU :{' '}
                    <a href="tel:+3281725080">+32 81 72 50 80</a> | {' '}
                    <a href="mailto:secretariat.vecu@unamur.be">secretariat.vecu@unamur.be</a>
                </p>
                <p className="num">
                    La Cellule sociale :{' '}
                    <a href="tel:+3281725085">+32 81 72 50 85</a> | {' '}
                    <a href="mailto:sse@unamur.be">sse@unamur.be</a>
                </p>
                <p className="num">
                    La Cellule Médico-psychologique :{' '}
                    <a href="tel:+3281725077">+32 81 72 50 77</a> | {' '}
                    <a href="mailto:cmp@unamur.be">cmp@unamur.be </a>
                </p>
                <p className="num">
                    Protection harcèlement étudiant :{' '}
                    <a href="tel:081725757">081 72 57 57</a> |{' '}
                    <a href="mailto:phare@unamur.be">phare@unamur.be</a>
                </p>
                <p className="num">
                    Centre de prévention au Suicide :{' '}
                    <a href="tel:080032123">0800 32 123</a>
                </p>
                <p className="num">
                    SOS viol : <a href="tel:025343636">02 534 36 36</a>
                </p>
                <p className="num">
                    SOS solitude : <a href="tel:025489808">02 548 98 08</a>
                </p>
                <p className="num">
                    Écoute jeunes : <a href="tel:078154422">078 15 44 22</a>
                </p>
                <p className="num">
                    Info-Drogues : <a href="tel:022275252">02 227 52 52</a>
                </p>
                <p className="num">
                    Centre anti-poison : <a href="tel:070245245">070 24 52 45</a>
                </p>
                <p className="num">
                    Médecins de garde : <a href="tel:090010512">0900 10 512</a>
                </p>
                <p className="num">
                    Pharmacies de garde :{' '}
                    <a href="tel:090010500">0900 10 500</a>
                </p>
                <p className="num">
                    Gardiennage : <a href="tel:081724051">081 72 40 51</a> -{' '}
                    <a href="tel:0496554050">0496 55 40 50</a>
                </p>
            </div>
        </div>
    );
}

export default Emergency;
